export default __webpack_public_path__ + "half-star-shape.png";